var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back-to-top",style:({transform: 'scale('+ _vm.itemScale +')'})},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"javascript:scroll(0,0)"}},[_c('i',{staticClass:"bi bi-rocket-takeoff"})])
}]

export { render, staticRenderFns }